<div class="card-header border-0">
    <div class="d-grid d-sm-flex align-items-center justify-content-sm-end flex-wrap ">
        <h5 *ngIf="tableConfig.listTitle" class="flex-grow-1 fs-17 pt-1" i18n="@@">
            {{tableConfig.listTitle}}</h5>

        <div class=" d-grid d-sm-flex justify-content-sm-end flex-wrap">
            <div *ngFor="let button of tableConfig.buttons">
                <span *ngIf="(button.type === enumButtonType.Default && getIfVisibleStatus(button.visible) == true)"
                    class="btn {{button.color}} ms-sm-2 mt-2" (click)="buttonActionSelected.emit(button.action)">
                    <i class="{{button.icon}} me-1 align-middle fs-15"></i>
                    <span i18n="@@"> {{button.label}} </span>
                </span>
                <span
                    *ngIf="(button.type === enumButtonType.CheckBoxSelected && getIfVisibleStatus(button.visible) == true) && (checkedValGet.length > 0)"
                    class="btn {{button.color}} ms-sm-2 mt-2" (click)="onCheckBoxButtonClicked(button.action)">
                    <i [ngClass]="{'align-items-center': !button.label, 'd-table-cell': !button.label }"
                        class="{{button.icon}} me-1 align-middle fs-15 "></i>
                    <span *ngIf="button.label" i18n="@@"> {{button.label}} </span>
                </span>
                <div *ngIf="(button.type === enumButtonType.Dropdown && getIfVisibleStatus(button.visible) == true)"
                    ngbDropdown>
                    <span class="btn {{button.color}} ms-sm-2 mt-2 dropdown arrow-none pointer" type="button"
                        data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                        <i *ngIf="button.icon && (button.iconIsAfterLabel==false)"
                            class="{{button.icon}} me-1 align-middle fs-15"></i>
                        <span *ngIf="button.label" i18n="@@"> {{button.label}} </span>
                        <i *ngIf="button.icon && (button.iconIsAfterLabel==true)"
                            class="{{button.icon}} align-middle fs-15"></i>
                    </span>
                    <ul class="dropdown-menu absolute " ngbDropdownMenu>
                        <span *ngFor="let action of button.actions">
                            <li class="p-2" *ngIf="getIfVisibleStatus(action.visible)">
                                <button class="btn {{action.color}} w-full"
                                    (click)="buttonActionSelected.emit(action.value)">
                                    {{action.text}}</button>
                            </li>
                        </span>
                    </ul>
                </div>
            </div>
            <div>
                <div *ngIf="tableConfig.searchbarFilter != undefined && tableConfig.searchbarFilter.filter && tableConfig.searchbarFilter.filter.sections"
                    class="btn btn-soft-info dropdown ms-sm-2 mt-2" (click)="openEnd(filterContent)">
                    <i class="ri-filter-3-line align-bottom fs-15 "></i>
                    Search Filters
                </div>
            </div>
            <div>
                <div *ngIf="(tableConfig.showReload)" class="btn btn-soft-info dropdown ms-sm-2 mt-2"
                    (click)="reloadListAdjustmentModal()">
                    <!-- <i class="ri-history-line align-middle fs-15"></i> -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path
                            d="M6.34 6.34c.73-.73 1.59-1.31 2.54-1.71.99-.42 2.03-.63 3.11-.63V2c-1.35 0-2.66.26-3.89.79-1.19.5-2.26 1.23-3.18 2.14-.92.92-1.64 1.99-2.14 3.18-.52 1.23-.79 2.54-.79 3.89s.26 2.66.79 3.89c.5 1.19 1.22 2.26 2.14 3.18.17.17.35.32.52.48L2.99 22h6v-6l-2.13 2.13c-.18-.15-.36-.31-.52-.48a8.1 8.1 0 0 1-1.72-2.54c-.42-.99-.63-2.03-.63-3.11s.21-2.13.63-3.11c.4-.95.98-1.81 1.72-2.54Zm12.73-1.41c-.17-.17-.35-.32-.52-.48L21 2h-6v6l2.13-2.13c.18.15.36.31.52.48.74.74 1.31 1.59 1.72 2.54.42.99.63 2.03.63 3.11s-.21 2.13-.63 3.11c-.4.95-.98 1.81-1.72 2.54-.73.73-1.59 1.31-2.54 1.71-.99.42-2.03.63-3.11.63v2c1.35 0 2.66-.26 3.89-.79 1.19-.5 2.26-1.23 3.18-2.14.92-.92 1.64-1.99 2.14-3.18.52-1.23.79-2.54.79-3.89s-.26-2.66-.79-3.89a9.9 9.9 0 0 0-2.14-3.18Z">
                        </path>
                    </svg>

                </div>
            </div>
            <div>
                <div *ngIf="(tableConfig.showArrangeOptions)" class="btn btn-soft-info dropdown ms-sm-2 mt-2"
                    (click)="openListAdjustmentModal()">
                    <i class="mdi mdi-cog-outline align-middle fs-15 "></i>
                </div>
            </div>

        </div>
    </div>
</div>
<div *ngIf="(tableConfig.searchbarFilter || tableConfig.filters) && showFilterAndSearchArea"
    class="card-header card-body bg-soft-light border border-dashed border-start-0 border-end-0">
    <div class="row g-3">
        <div class="col-md-6 " *ngIf="tableConfig.searchbarFilter">
            <span class="d-flex gap-2">
                <div class="d-flex align-items-center gap-2" style="width: -webkit-fill-available;">
                    <div style="width: -webkit-fill-available;">
                        <div class="search-box flex-grow-1">
                            <input type="text" name="searchTerm" class="form-control search bg-light border-light"
                                placeholder="{{tableConfig.searchbarFilter.placeHolderText}}"
                                [(ngModel)]="tableConfig.searchbarFilter.value" (ngModelChange)="searchTermUpdated()">
                            <i class="ri-search-line search-icon"></i>
                            <i class="mdi mdi-close-circle search-widget-icon search-widget-icon-close position-absolute cursor-pointer top-0 h-full d-flex align-items-center"
                                *ngIf="tableConfig.searchbarFilter.value && tableConfig.searchbarFilter.value.length >0"
                                style="font-size: 1rem;
                    right: 13px;
                    color: #878a99;" (click)="clearSearchSelected()"></i>
                        </div>
                        <div *ngIf="searchTermContainsInvalidCharacters == true">
                            <div class="invalidInputTextMessage">{{searchTermInvalidCharacterMessage}}</div>
                        </div>
                    </div>
                </div>
            </span>
        </div>

        <div class="col-12 col-sm-6 col-lg-3" *ngIf="tableConfig.dateFilter">
            <div class="d-flex align-items-center gap-2 bg-light border-light form-control">
                <input type="text" class="form-control bg-light border-0 p-0" placeholder="Select date/range"
                    [(ngModel)]="tableConfig.dateFilter.dateRange" (flatpickrClose)="dateUpdated($event)" mwlFlatpickr [disableMobile]="true"
                    [convertModelValue]="true" mode="range" altFormat="d M, Y" dateFormat="d M, Y">
                <i *ngIf="checkIfDateFilterExists(tableConfig.dateFilter.dateRange)"
                    class="mdi mdi-close-circle search-widget-icon search-widget-icon-close cursor-pointer  d-flex align-items-center"
                    style="
                    line-height: 0; font-size: 1rem; color: #878a99;" (click)="clearDateSelected()"></i>
            </div>
        </div>
        <div *ngFor="let filter of tableConfig.filters; index as j " class="col-md-3"
            [ngStyle]="{'display': (filter.inDropdown && (!filter.isHidden)) ? 'block': 'none'} ">
            <app-ng-select-layout-filter [placeHolderText]="filter.options[0].selectedText"
                (statusChanged)="filterSelectedEmit(j,$event)" [items]="filter.options"></app-ng-select-layout-filter>
        </div>


        <div class="col-md-auto ms-auto" *ngFor="let filter of tableConfig.filters; index as i"
            [ngStyle]="{'display': (filter.inButton && (!filter.isHidden)) ? 'block': 'none'} ">
            <div class="d-flex align-items-center gap-2">
                <div ngbDropdown>
                    <button type="button" id="dropdownMenuLink1" data-bs-toggle="dropdown" aria-expanded="false"
                        class="btn btn-soft-info arrow-none" ngbDropdownToggle>
                        <i class="ri-more-2-fill"></i></button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink1" ngbDropdownMenu>
                        <li *ngFor="let option of filter.options; index as j ">
                            <a class="dropdown-item" href="javascript:void(0);" (click)="onFilterClicked(i,j)">
                                <span i18n="@@">{{option.selectedText}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="col-md-auto ms-auto" *ngFor="let filter of tableConfig.filters; index as i"
            [ngStyle]="{'display': (filter.inButtonArray && (!filter.isHidden)) ? 'block': 'none'} ">
            <div class="d-flex align-items-center">
                <span *ngFor="let option of filter.options; index as j ">
                    <button type="button" aria-expanded="false" class="btn btn-select-array"
                        [ngClass]='selectButtonArrayClass(filter,option,j)' (click)="onFilterClicked(i,j)">
                        {{option.selectedText}}</button>
                </span>

            </div>
        </div>
    </div>
</div>
<div class="card-body p-0">
    <div class="nav-tabs-custom">
        <div class="mx-3">
            <ul *ngFor="let filter of tableConfig.filters; index as i" ngbNav #nav="ngbNav"
                (navChange)="onNavChange(i,$event)" [ngStyle]="{'display': (filter.inHeading) ? '': 'none'} "
                class="nav nav-tabs nav-tabs-custom nav-success ">
                <li *ngFor="let option of filter.options; index as j " [ngbNavItem]="j">
                    <a ngbNavLink class="">
                        <i class="{{option.icon}} me-1 align-middle fs-15"></i>
                        {{option.selectedText}}
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <div class="mb-0 px-3">
        <div class="table-responsive table-card mt-0 mb-0">
            <table class="table align-middle table-nowrap mb-0">
                <thead class="text-muted table-light d-table w-full">
                    <tr>
                        <th *ngFor="let column of tableConfig.columns"
                            [ngStyle]="{'display': (getIfVisibleStatus(column.visible) == false) ? 'none' :''} ">
                            <div *ngIf="getIfVisibleStatus(column.visible)" class="overflow-auto flex-nowrap "
                                style=" width: {{column.width}} !important;">
                                <div *ngIf="column.type !== enumColumnType.CheckBox"
                                    class="d-flex justify-content-between">
                                    <div class="flex-grow-1 " i18n="@@" style="text-transform: capitalize;">
                                        {{column.title}}
                                    </div>
                                    <div *ngIf="column.sortable !== undefined" class="flex-shrink-0 cursor-pointer">
                                        <div *ngIf='emitSortModel.fieldName == undefined || (emitSortModel.fieldName != column.dataFieldName && emitSortModel.fieldName != column.sortable.altSearchFieldName ) || ((emitSortModel.fieldName == column.dataFieldName || emitSortModel.fieldName == column.sortable.altSearchFieldName) && emitSortModel.sortSelected == column.sortable.defaultSortValue)'
                                            class="bx bxs-sort-alt me-1"
                                            (click)="emitSortBy(column.sortable.ascSortValue, column.dataFieldName, column.sortable.altSearchFieldName)">
                                        </div>
                                        <div *ngIf='((emitSortModel.fieldName == column.dataFieldName || emitSortModel.fieldName == column.sortable.altSearchFieldName) && emitSortModel.sortSelected == column.sortable.ascSortValue)'
                                            class="bx bx-caret-up me-1"
                                            (click)="emitSortBy(column.sortable.descSortValue, column.dataFieldName, column.sortable.altSearchFieldName)">
                                        </div>
                                        <div *ngIf='((emitSortModel.fieldName == column.dataFieldName || emitSortModel.fieldName == column.sortable.altSearchFieldName) && emitSortModel.sortSelected == column.sortable.descSortValue)'
                                            class="bx bx-caret-down me-1"
                                            (click)="emitSortBy(column.sortable.defaultSortValue, column.dataFieldName, column.sortable.altSearchFieldName)">
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="column.type === enumColumnType.CheckBox" class="form-check">
                                    <input class="form-check-input cursor-pointer" type="checkbox" id="checkAll"
                                        value="option" [(ngModel)]="masterSelected"
                                        (change)="checkUncheckAll($event,listItems)">
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="list form-check-all overflow-auto d-block overflow-x-hidden"
                    style="max-height: {{maxListHeight}}px">
                    <tr *ngFor="let data of listItems; index as index;" id="i_{{data.id}}" class="w-full d-table"
                        (click)="selectRow(data,index)">

                        <td *ngFor="let column of tableConfig.columns"
                            [ngStyle]="{'display': (getIfVisibleStatus(column.visible) == false) ? 'none' :''} ">
                            <div *ngIf="getIfVisibleStatus(column.visible)" class="overflow-scroll flex-nowrap"
                                style=" width: {{column.width}} !important; ">
                                <div *ngIf="column.type === enumColumnType.String">
                                    <ngb-highlight [result]="columnData(column.dataFieldName, data)"
                                        class="cursor-default">
                                    </ngb-highlight>
                                </div>
                                <div *ngIf="column.type === enumColumnType.BackupString">
                                    <ngb-highlight
                                        *ngIf="columnData(column.dataFieldName, data) !== '' else elseBackupString"
                                        [result]="columnData(column.dataFieldName, data)" class="cursor-default">
                                    </ngb-highlight>
                                    <ng-template #elseBackupString>
                                        <ngb-highlight [result]="columnData(column.subDataFieldName, data)"
                                            class="cursor-default">
                                        </ngb-highlight>
                                    </ng-template>
                                </div>
                                <div *ngIf="column.type === enumColumnType.ValueInSubModel">
                                    <ngb-highlight
                                        [result]="columnData(column.subDataFieldName, columnData(column.dataFieldName, data))"
                                        class="cursor-default">
                                    </ngb-highlight>
                                </div>
                                <div *ngIf="column.type === enumColumnType.ValueInArrayFirstIndex">
                                    <ngb-highlight
                                        [result]="columnData(column.subDataFieldName, columnData(column.dataFieldName, data)[0])"
                                        class="cursor-default">
                                    </ngb-highlight>
                                </div>
                                <div *ngIf="column.type === enumColumnType.AssigneeArray" class="d-flex">
                                    <span
                                        *ngIf="columnData(column.dataFieldName, data) != undefined && columnData(column.dataFieldName, data).length > 0">
                                        <a *ngFor="let assignee of (columnData(column.dataFieldName, data))"
                                            href="javascript:void(0);" class="avatar-group-item me-2"
                                            style="cursor: default !important;" placement="top"
                                            data-bs-toggle="tooltip">
                                            <img [src]="profilePhotoPNGTransform(assignee)"
                                                class=" avatar-xs rounded-circle me-2">
                                            <ngb-highlight [result]="assignee.fullName">
                                            </ngb-highlight>
                                        </a>
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.Amount">
                                    <ngb-highlight [result]="(columnData(column.dataFieldName, data)|currency)">
                                    </ngb-highlight>
                                </div>
                                <div *ngIf="column.type === enumColumnType.Status">
                                    <span class="rounded" [ngClass]='statusTextClass(data.status)'>
                                        {{statusText(data.status)}}
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.SubStatus">
                                    <span class="rounded"
                                        [ngClass]='customStatus(column.customStatusClass,  "status" ,columnData(column.dataFieldName, data))'>
                                        {{customStatus(column.customStatusText, 'status',
                                        columnData(column.dataFieldName, data))}}
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.StatusCustom">
                                    <span class="rounded"
                                        [ngClass]='customStatus(column.customStatusClass, column.dataFieldName, data)'>
                                        {{customStatus(column.customStatusText, column.dataFieldName, data)}}
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.StatusCustomArray">
                                    <span class="d-flex gap-2">
                                        <span *ngFor="let obj of columnData(column.dataFieldName, data)"
                                            class="rounded "
                                            [ngClass]='customStatus(column.customStatusClass, column.dataFieldName, obj,true)'>
                                            {{customStatus(column.customStatusText, column.dataFieldName, obj,true)}}
                                        </span>
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.InlineEditingString">
                                    <span class="rounded">
                                        <input [disabled]="inputFieldEnabled(index)" class="form-control"
                                            [ngModel]="columnData(column.dataFieldName, data)"
                                            (ngModelChange)="onInlineUpdate($event, column.dataFieldName, data, listItems, index)" />
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.InlineEditingDropdown">
                                    <span class="rounded">
                                        <app-ng-select-layout [placeHolderText]="'Select an Option'"
                                            [disableInput]="inputFieldEnabled(index)"
                                            [model]="columnData(column.dataFieldName, data)"
                                            (modelChange)="onInlineUpdate($event, column.dataFieldName, data, listItems, index)"
                                            [items]="column.inlineEditingDropDownOptions"></app-ng-select-layout>
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.CustomUserInputFromConfig">
                                    <ngb-highlight [result]="column.dataFieldName" class="cursor-default">
                                    </ngb-highlight>
                                </div>
                                <div *ngIf="column.type === enumColumnType.TimeSpent">
                                    <span class="rounded">
                                        {{renameDataTimeSpent(columnData(column.dataFieldName, data))}}
                                    </span>
                                </div>

                                <div *ngIf="column.type === enumColumnType.Date">
                                    <span class="rounded">
                                        {{dateRename(columnData(column.dataFieldName,
                                        data),column.customDateDisplayOptionSelected)}}
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.LastActive">
                                    <time *ngIf="columnData(column.dataFieldName, data) else elseNoDate"
                                        style="text-transform: capitalize;">
                                        {{columnData(column.dataFieldName, data) | amTimeAgo:true}} ago
                                    </time>
                                    <ng-template #elseNoDate>
                                        <strong class="rounded"
                                            style="color: '#f1963b'; background-color: #f1963b1a; padding: 2px; font-size: .75em; font-weight: 500; padding-right: 0.65em; padding-left: 0.65em;">Not
                                            Seen</strong>
                                    </ng-template>
                                </div>
                                <div *ngIf="column.type === enumColumnType.FileSize">
                                    <span class="rounded">
                                        {{renameFileSize(columnData(column.dataFieldName, data))}}
                                    </span>
                                </div>
                                <div *ngIf="column.type === enumColumnType.ArrayPhotoModel">
                                    <div class="d-flex align-items-center"
                                        *ngFor="let model of columnData(column.dataFieldName, data)">
                                        <span *ngIf="model != undefined" class="d-flex align-items-center">
                                            <div class="flex-shrink-0 gap-2">
                                                <img [src]="profilePhotoPNGTransform(model)" alt=""
                                                    class=" avatar-xs rounded-circle me-2">
                                            </div>
                                            <a href="javascript:void(0);"
                                                (click)="onRowActionClicked(enumActionId.Edit,data,index); stopPropagationOnClick($event);">
                                                <ngb-highlight
                                                    [result]="modelsArray(data.entityType , column.arrayModels!, model )">
                                                </ngb-highlight>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                                <div *ngIf="column.type === enumColumnType.Model">
                                    <a href="javascript:void(0);"
                                        (click)="onRowActionClicked(enumActionId.Edit,data,index); stopPropagationOnClick($event);">
                                        <ngb-highlight [result]="columnData(column.dataFieldName, data)">
                                        </ngb-highlight>
                                    </a>
                                </div>
                                <div *ngIf="column.type === enumColumnType.SubModel">
                                    <a href="javascript:void(0);"
                                        (click)="onRowActionClicked(enumActionId.Edit,columnData(column.dataFieldName, data),index); stopPropagationOnClick($event);">
                                        <ngb-highlight
                                            [result]="columnData(column.subDataFieldName, columnData(column.dataFieldName, data))">
                                        </ngb-highlight>
                                        <p class="mb-0 fs-12 text-muted">
                                            <ngb-highlight
                                                *ngIf="columnData(column.underTextDataFieldName, columnData(column.dataFieldName, data))"
                                                [result]="columnData(column.underTextDataFieldName, columnData(column.dataFieldName, data))">
                                            </ngb-highlight>
                                        </p>
                                    </a>
                                </div>
                                <div *ngIf="column.type === enumColumnType.SubPhotoModel">
                                    <div *ngIf="columnData(column.dataFieldName, data) != '' "
                                        class="d-flex align-items-center">
                                        <div class="flex-shrink-0 gap-2">
                                            <img *ngIf="column.imageUrlLink === undefined"
                                                [src]="profilePhotoPNGTransform(columnData(column.dataFieldName, data))"
                                                alt="" class=" avatar-xs rounded-circle me-2">
                                            <img *ngIf="column.imageUrlLink"
                                                [src]="getDocumentImageUrl(columnData('imageUrl', columnData(column.dataFieldName, data)))"
                                                alt="" class=" avatar-xs rounded-circle me-2">
                                        </div>
                                        <a href="javascript:void(0);"
                                            (click)="onRowActionClicked(enumActionId.Edit,columnData(column.dataFieldName, data),index); stopPropagationOnClick($event);">
                                            <ngb-highlight
                                                [result]="columnData(column.subDataFieldName, columnData(column.dataFieldName, data))">
                                            </ngb-highlight>
                                            <p class="mb-0 fs-12 text-muted">
                                                <ngb-highlight
                                                    *ngIf="columnData(column.underTextDataFieldName, columnData(column.dataFieldName, data))"
                                                    [result]="columnData(column.underTextDataFieldName, columnData(column.dataFieldName, data))">
                                                </ngb-highlight>
                                            </p>
                                        </a>

                                    </div>
                                </div>
                                <div *ngIf="column.type === enumColumnType.PhotoModel">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0 gap-2">
                                            <img *ngIf="column.imageUrlLink === undefined"
                                                [src]="profilePhotoPNGTransform(data)" alt=""
                                                class=" avatar-xs rounded-circle me-2">
                                            <img *ngIf="column.imageUrlLink"
                                                [src]="getDocumentImageUrl(columnData('imageUrl', data))" alt=""
                                                class=" avatar-xs rounded-circle me-2">
                                        </div>
                                        <a href="javascript:void(0);"
                                            (click)="onRowActionClicked(enumActionId.Edit,data,index); stopPropagationOnClick($event);">
                                            <ngb-highlight [result]="columnData(column.dataFieldName, data)">
                                            </ngb-highlight>
                                            <p class="mb-0 fs-12 text-muted">
                                                <ngb-highlight *ngIf="column.underTextDataFieldName"
                                                    [result]="columnData(column.underTextDataFieldName,data)">
                                                </ngb-highlight>
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div *ngIf="column.type === enumColumnType.CheckBox">
                                    <div class="form-check">
                                        <input class="form-check-input cursor-pointer" type="checkbox" name="checkAll"
                                            value="{{data.id}}" (click)="stopPropagationOnClick($event)"
                                            (change)="onCheckboxChange($event, listItems)"
                                            [(ngModel)]="data.checkBoxState">
                                    </div>
                                </div>
                                <div *ngIf="column.type === enumColumnType.Action">
                                    <ul class="list-inline hstack mb-0">
                                        <span *ngFor="let action of tableConfig.actions">
                                            <li *ngIf="action.inList" class="ms-1">
                                                <button
                                                    *ngIf="((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues == undefined)) || ((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues != undefined) && (showAction(action.visibleOnValues, data, action.dataFieldName, action.visibilityByValueIsEnum, action.visibilityByContainsSubString, action.subStringDataFieldName, action.visibilitySubString,  action.label,column.dataFieldName)))"
                                                    (click)="onRowActionClicked(action.actionId,data,index,listItems); stopPropagationOnClick($event);"
                                                    class="dropdown-item" href="javascript:void(0);"><i
                                                        class="{{action.icon}} align-bottom me-2 text-muted"
                                                        style="font-size: large;"></i>
                                                </button>
                                                <span
                                                    *ngIf="!(((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues == undefined)) || ((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues != undefined) && (showAction(action.visibleOnValues, data, action.dataFieldName, action.visibilityByValueIsEnum, action.visibilityByContainsSubString, action.subStringDataFieldName, action.visibilitySubString, action.label,column.dataFieldName)))) && (action.showBlankIfHidden == true)"
                                                    class="blankPlaceHolder">
                                                </span>
                                            </li>
                                        </span>
                                        <li class="list-inline-item ms-2">
                                            <div class="dropdown position-static" ngbDropdown
                                                data-popper-placement="bottom-end" style="z-index: 100;">
                                                <button
                                                    class="btn btn-soft-secondary btn-sm dropdown arrow-none cursor-pointer"
                                                    type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                                    ngbDropdownToggle>
                                                    <i class="ri-more-fill align-middle"></i>
                                                </button>
                                                <ul class="dropdown-menu position-absolute" ngbDropdownMenu>
                                                    <span *ngFor="let action of tableConfig.actions" [ngStyle]="{'display': (
                                                        (((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues == undefined)) || ((getIfVisibleStatus(action.visible) == true) && (action.visibleOnValues != undefined) && (showAction(action.visibleOnValues, data, action.dataFieldName, action.visibilityByValueIsEnum, action.visibilityByContainsSubString, action.subStringDataFieldName, action.visibilitySubString, action.label,column.dataFieldName))))
                                                            ) ? '' :'none'} ">
                                                        <li *ngIf="action.inDropdown">
                                                            <button ngbTooltip="{{action.tooltip}}"
                                                                (click)="onRowActionClicked(action.actionId,data,index); stopPropagationOnClick($event);"
                                                                class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="{{action.icon}} align-bottom me-2"
                                                                    [ngClass]='customColorIcon(action.color)'></i>
                                                                {{action.label}}</button>
                                                        </li>
                                                    </span>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <!-- <div class="resize-handle" cdkDrag cdkDragBoundary="resizable-container" (cdkDragMoved)="onResize($event)" ></div> -->
                </tbody>
                <thead *ngIf="tableConfig.displayTabulation"
                    class="text-muted table-light d-table w-full bg-soft-light border border-dashed border-start-0 border-end-0">
                    <tr>
                        <th *ngFor="let column of tableConfig.columns"
                            [ngStyle]="{'display': (getIfVisibleStatus(column.visible) == false) ? 'none' :''} ">
                            <div *ngIf="getIfVisibleStatus(column.visible)" class="overflow-auto flex-nowrap "
                                style=" width: {{column.width}} !important;">
                                <div *ngIf="(column.type !== enumColumnType.CheckBox) && (column.tabulate === true)"
                                    class="d-flex justify-content-between">
                                    <div class="flex-grow-1 " i18n="@@" style="text-transform: capitalize;">
                                        <span *ngIf="column.tabulationPlaceHolder else elseNotPlaceholder">
                                            {{column.tabulationTitle}}
                                        </span>
                                        <ng-template #elseNotPlaceholder>
                                            <span>
                                                {{tabulateTotal(column.dataFieldName,column.tabulationTitle,column.tabulationComparisonDataFieldName,column.tabulationComparisonValue)}}
                                            </span>
                                        </ng-template>
                                    </div>

                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</div>
<div *ngIf="tableConfig.enablePagination" class=" card-body ">
    <div class="row justify-content-md-between align-items-md-center">
        <div class="d-flex gap-2 col col-sm-6">
            <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                {{pagingInfo()}}
            </div>
        </div>
        <div class="col col-sm-6">
            <div class="text-sm-right float-end listjs-pagination">
                <ngb-pagination [collectionSize]="serviceData.totalRecords" [pageSize]="serviceData.pageSize"
                    [(page)]="serviceData.page" (pageChange)="this.paginationSelected.emit(serviceData.page)">
                    <ng-template ngbPaginationPages let-page let-pages="pages">
                        <li class="ngb-custom-pages-item">
                            <div class="mb-3 d-flex flex-nowrap px-2">
                                <label id="paginationInputLabel" for="paginationInput"
                                    class="col-form-label me-2 ms-1">Page</label>
                                <input #i type="text" inputmode="numeric" pattern="[0-9]*"
                                    class="form-control custom-pages-input text-align-center" id="paginationInput"
                                    [value]="serviceData.page" (keyup.enter)="selectPage(i.value)"
                                    (blur)="selectPage(i.value)" (input)="formatInput($any($event).target)"
                                    aria-labelledby="paginationInputLabel paginationDescription"
                                    style="width:3.5rem;" />
                                <span id="paginationDescription" class="col-form-label text-nowrap px-2"> <span
                                        i18n="@@Pagination_Text_Of">of</span> {{
                                    pages.length }}</span>
                            </div>
                        </li>
                    </ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>
<div *ngIf="serviceData.loadingValue" id="elmLoader">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>


<ng-template #filterContent let-offcanvas>
    <div class="offcanvas-header bg-light">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">Search Filters</h5>
        <button type="button" class="btn-close text-body" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="offcanvas.dismiss('Cross click')"></button>
    </div>
    <!--end offcanvas-header-->
    <form action="" class="d-flex flex-column justify-content-end h-100">
        <div class="offcanvas-body">
            Select all filters that you wish to apply to your search
            <div *ngFor="let section of tableConfig.searchbarFilter!.filter!.sections!; index as j ">
                <label for="leads-tags"
                    class="form-label text-muted text-uppercase fw-semibold mt-3">{{section.sectionTitle}}</label>
                <div class="row g-3">
                    <div *ngFor="let option of section.options!; index as j " class="col-lg-6">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" [checked]="option.isSelected"
                                (change)="option.isSelected = !option.isSelected; applySearchbarFilterOption();">
                            <label class="form-check-label"
                                (click)="option.isSelected = !option.isSelected; applySearchbarFilterOption();">{{option.text}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end offcanvas-body-->
        <div class="offcanvas-footer border-top p-3 text-center hstack gap-2">
            <button (click)="clearSearchbarFilterOption()" class="btn btn-light w-100">Clear</button>
            <button (click)="applySearchbarFilterOption(true)" type="submit"
                class="btn btn-success w-100">Apply</button>
        </div>
    </form>
</ng-template>